import React from 'react';
import PreFormWizardWithCategory from '@/features/submission_forms/PreFormWizardWithCategory';

const StudiesNew: React.FC = () => (
  <PreFormWizardWithCategory
    category="Initial Review of Protocol"
    pageTitle="New Study"
    backPath="/studies"
  />
);

export default StudiesNew;
